import axios from 'axios';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { QTask, QTaskFilter, REACT_APP_QWEALTH_API, REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';
import { QTaskComment } from 'data/models/Activity';

export type TaskResult = {
  data: QTask[];
  message?: string;
};

export const getAllTasks = async (filters: QTaskFilter): Promise<QTask[]> =>
  axios.get(`${REACT_APP_QWEALTH_API_V3}/task`, { params: filters }).then(response => responseListMapper<QTask>(response));

export const updateTask = async (task: QTask): Promise<QTask[]> =>
  axios.patch(`${REACT_APP_QWEALTH_API_V3}/task/${task.id}`, task).then(response => responseListMapper<QTask>(response));

export const deleteTask = async (task: QTask): Promise<QTask[]> =>
  axios
    .delete(`${REACT_APP_QWEALTH_API_V3}/task/${task.id}`, {
      params: { deleteFollowingTasks: task.deleteFollowingTasks },
    })
    .then(response => responseListMapper<QTask>(response));

export const generateTask = async (task: QTask): Promise<TaskResult> => {
  const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/task`, task);
  return {
    data: responseListMapper<QTask>(response),
    message: response.status === 207 ? response.data?.message : undefined,
  };
};

export const getTaskCommentsApi = async (taskId: number): Promise<QTaskComment[]> =>
  axios.get(`${REACT_APP_QWEALTH_API}/comments`, { params: { taskId: taskId } }).then(response => responseListMapper<QTaskComment>(response));

export const postTaskCommentApi = (comment: QTaskComment): Promise<QTaskComment> =>
  axios.post(`${REACT_APP_QWEALTH_API}/comments`, comment).then(response => responseEntityMapper<QTaskComment>(response));

export const deleteTaskCommentApi = async (commentId: string) => axios.delete(`${REACT_APP_QWEALTH_API}/comments/${commentId}`);
